import { render, staticRenderFns } from "./BuyNow.vue?vue&type=template&id=0f5c07fb&scoped=true"
import script from "./BuyNow.vue?vue&type=script&lang=js"
export * from "./BuyNow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5c07fb",
  null
  
)

export default component.exports